import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { UrlService } from 'app/core/http/url.service';
import { LocaleModel } from 'app/core/languages/locale-model';

@Injectable({
  providedIn: 'root'
})
export class LanguagesService {
  private readonly httpClient = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public appendCountryIfNeeded(locales: LocaleModel[]): LocaleModel[] {
    return locales.map((locale) => {
      const moreThenOneLanguage = locales.filter((l) => l.Language === locale.Language).length > 1;

      if (!moreThenOneLanguage) {
        return locale;
      }

      return {
        ...locale,
        Language: `${locale.Language} (${locale.Country})`
      };
    });
  }

  public getAvailableLocales(): Observable<LocaleModel[]> {
    const url = this.urlService.buildServerApiUrl('Locales');

    return this.httpClient.get<LocaleModel[]>(url).pipe(map((locales) => this.appendCountryIfNeeded(locales)));
  }

  public getAllAvailableLocales(): Observable<LocaleModel[]> {
    const url = this.urlService.buildServerApiUrl('Locales/All');
    return this.httpClient.get<LocaleModel[]>(url);
  }
}
